/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Flex, View } from "@aws-amplify/ui-react";
export default function TechSquares(props) {
  const {
    techDividerGroup,
    iconGroup1,
    iconGroup2,
    iconGroup3,
    iconGroup4,
    iconGroup5,
    iconGroup6,
    iconGroup7,
    iconGroup8,
    iconGroup9,
    iconGroup10,
    iconGroup11,
    iconGroup12,
    overrides,
    ...rest
  } = props;
  return (
    <View
      width="1440px"
      height="480px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "TechSquares")}
      {...rest}
    >
      <View
        padding="0px 0px 0px 0px"
        width="1440px"
        height="480px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0px"
        left="0px"
        children={techDividerGroup}
        {...getOverrideProps(overrides, "TechDividerGroup")}
      ></View>
      <Flex
        gap="0"
        direction="column"
        width="1440px"
        height="480px"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="absolute"
        top="calc(50% - 240px - 0px)"
        left="calc(50% - 720px - 0px)"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "IconSquares")}
      >
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "TopSquares")}
        >
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup1}
            {...getOverrideProps(overrides, "IconGroup1")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup2}
            {...getOverrideProps(overrides, "IconGroup2")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup3}
            {...getOverrideProps(overrides, "IconGroup3")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup4}
            {...getOverrideProps(overrides, "IconGroup4")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup5}
            {...getOverrideProps(overrides, "IconGroup5")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup6}
            {...getOverrideProps(overrides, "IconGroup6")}
          ></Flex>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "BottomSquares")}
        >
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup7}
            {...getOverrideProps(overrides, "IconGroup7")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup8}
            {...getOverrideProps(overrides, "IconGroup8")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup9}
            {...getOverrideProps(overrides, "IconGroup9")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup10}
            {...getOverrideProps(overrides, "IconGroup10")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup11}
            {...getOverrideProps(overrides, "IconGroup11")}
          ></Flex>
          <Flex
            padding="0px 0px 0px 0px"
            width="240px"
            height="240px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            children={iconGroup12}
            {...getOverrideProps(overrides, "IconGroup12")}
          ></Flex>
        </Flex>
      </Flex>
    </View>
  );
}
